import { API } from '~apis/axios/instance';
import { CompanyInfo } from '~types/company';
import { ResponseBase } from '~types/response';

export interface GetCompanyResponse extends ResponseBase {
  data: CompanyInfo;
}

interface CompanyIdentifier {
  companyId: string;
}

/**
 * 회사정보 조회
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/company-controller/getCompanyDetail
 *
 */
export default function getCompany({ companyId }: CompanyIdentifier) {
  return API.get<GetCompanyResponse>(`/api/v2/companies/${companyId}`);
}
